requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('pickup-availability')) {
      customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
        connectedCallback() {
          this.onClickRefreshListBound ??= this.onClickRefreshList.bind(this);
          this.onClickRefreshList = this.onClickRefreshListBound;
          this.errorHtml ??= this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
          this.nativeController = this.closest('.product')?.querySelector('variant-media-controller');
          this.nativeController?.initialize?.();
          if (this.nativeController?.initialized) {
            this.setLocalAvailability(this.nativeController.selectedVariantId, this.nativeController.getState()?.pickupHtml || '');
          } else if (this.hasAttribute('available')) {
            this.fetchAvailability(this.dataset.variantId);
          }
        }

        disconnectedCallback() {
          if (this.drawer?.hasAttribute('open')) this.drawer.hide();
          this.drawer?.remove();
        }

        setLocalAvailability(variantId, markup) {
          this.dataset.variantId = variantId || '';
          const container = document.createElement('div');
          container.innerHTML = markup;
          const namespace = this.nativeController?.dataset.sectionId || variantId;
          container.querySelectorAll('[id], [aria-labelledby]').forEach(element => {
            if (element.id) element.id += '-' + namespace;
            if (element.hasAttribute('aria-labelledby')) element.setAttribute('aria-labelledby', element.getAttribute('aria-labelledby') + '-' + namespace);
          });
          this.renderPreview(container);
        }

        fetchAvailability(variantId) {
          if (this.nativeController?.initialized) {
            this.setLocalAvailability(variantId, this.nativeController.getState(variantId)?.pickupHtml || '');
            return;
          }
          this.dataset.variantId = variantId;
          let rootUrl = this.dataset.rootUrl;
          if (!rootUrl.endsWith("/")) {
            rootUrl = rootUrl + "/";
          }
          const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

          fetch(variantSectionUrl)
            .then(response => response.text())
            .then(text => {
              const sectionInnerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');
              this.renderPreview(sectionInnerHTML);
            })
            .catch(e => {
              const button = this.querySelector('button');
              if (button) button.removeEventListener('click', this.onClickRefreshList);
              this.renderError();
            });
        }

        onClickRefreshList(evt) {
          this.fetchAvailability(this.dataset.variantId);
        }

        renderError() {
          this.innerHTML = '';
          if (!this.errorHtml) return;
          this.appendChild(this.errorHtml.cloneNode(true));

          this.querySelector('button').addEventListener('click', this.onClickRefreshList);
        }

        renderPreview(sectionInnerHTML) {
          if (this.drawer?.hasAttribute('open')) this.drawer.hide();
          this.drawer?.remove();
          if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
            this.innerHTML = "";
            this.removeAttribute('available');
            return;
          }

          this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
          this.setAttribute('available', '');

          this.drawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
          if (this.drawer) document.body.appendChild(this.drawer);

          const button = this.querySelector('button');
          if (button) button.addEventListener('click', (evt) => {
            this.drawer?.show(evt.target);
          });
        }
      });

      scriptController.scripts.push('pickup-availability.js');
    }

    if (!customElements.get('pickup-availability-drawer')) {
      customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
        constructor() {
          super();

          themeBase.onDOMContentLoadedTrigger(() => {
            this.onBodyClick = this.handleBodyClick.bind(this);

            this.querySelector('button').addEventListener('click', () => {
              this.hide();
            });

            this.addEventListener('keyup', (event) => {
              if (event.code.toUpperCase() === 'ESCAPE') this.hide();
            });
          });
        }

        handleBodyClick(evt) {
          const target = evt.target;
          if (target != this && !target.closest('pickup-availability-drawer') && !this.focusElement?.contains(target)) {
            this.hide();
          }
        }

        hide() {
          this.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClick);
          themeBase.unfreezeScroll();
          removeTrapFocus(this.focusElement);
        }

        show(focusElement) {
          this.focusElement = focusElement;
          this.setAttribute('open', '');
          document.body.addEventListener('click', this.onBodyClick);
          themeBase.freezeScroll();
          trapFocus(this);
        }
      });
    }
  });
});